export const isRequired = { required: 'Ce champ est obligatoire.' };
